export default "__VITE_ASSET__0bc5121a__"